import { StateCreator } from 'zustand';
import { HistorySlice } from './history.types';

export const createHistorySlice: StateCreator<
  HistorySlice,
  [],
  [],
  HistorySlice
> = () => ({
  history: [],
});
